<template>
  <div>
    <search-form
      :fetchData="fetch"
      ref="searchFormRef"
      :handelSearch="handelSearch"
      :collection="formCollection"
      :addBtn="false"
    ></search-form>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      size="small"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'image'">
          <a-image
            :width="55"
            :src="record.image_url"
          />
        </template>
        <template v-else-if="column.key === 'device_name'">
          <span>{{ record.device?.name || '-' }}</span>
        </template>
        <table_data_format
          v-else
          :record="record"
          :column="column"
        ></table_data_format>
      </template>
    </a-table>
  </div>
</template>
<script setup>
  import { ref, onMounted, toRefs, computed } from 'vue'
  import { useStore } from 'vuex'
  import { getPerson as getData } from '@/api/gate_crossing_records'
  import searchForm from '@/components/search_form'
  import dayjs from 'dayjs'
  import { codeToText, constantToOptions } from '@/utils/format'
  import table_data_format from '@/components/table_data_format'
  import { gateCrossingResult } from '@/utils/common'
  //初始化
  const store = useStore()
  const Enum = toRefs(store.state.common)

  //1、搜索框
  const formCollection = [
    {
      type: 'input',
      field: 'idCard',
      label: '证件号码',
      'allow-clear': true,
    },
    {
      type: 'input',
      field: 'personName',
      label: '姓名',
      'allow-clear': true,
    },
    {
      type: 'select',
      field: 'openResult',
      label: '开门结果',
      width: '80px',
      // defaultValue: 1,
      options: constantToOptions(gateCrossingResult),
      'allow-clear': true,
    },
    {
      type: 'dateRange',
      startField: 'startDate',
      endField: 'endDate',
      defaultStart: dayjs().format('YYYY-MM-DD'),
      defaultEnd: dayjs().format('YYYY-MM-DD'),
      label: '日期',
    },
  ]
  const searchFormRef = ref()
  function handelSearch() {
    pagination.value.current = 1
    fetch()
    const params = {
      ...searchFormRef.value.formState
    }
    store.commit('search/setGatePerson', params)
  }

  //2、表格
  const columns = [
    {
      title: '日期',
      dataIndex: 'date',
      key: 'date',
      align: 'left',
    },
    {
      title: '姓名',
      dataIndex: 'person_name',
      key: 'person_name',
      align: 'left',
    },
    {
      title: '证件号',
      dataIndex: 'paper_number',
      key: 'paper_number',
      align: 'left',
    },
    {
      title: '访客类型',
      key: 'crossing_image_type',
      align: 'left',
    },
    {
      title: '卡状态',
      key: 'crossing_card_status',
      align: 'left',
    },
    {
      title: '卡号',
      key: 'card_number',
      align: 'left',
    },
    {
      title: '进出类型',
      key: 'person_event_type',
      align: 'left',
    },
    {
      title: '设备名称',
      dataIndex: 'device_name',
      key: 'device_name',
      align: 'left',
    },
    {
      title: '开门结果',
      key: 'open_result',
      dataIndex: 'open_result',
      align: 'left',
    },
    {
      title: '图片',
      key: 'image',
      align: 'left',
    },
    {
      title: '抓拍时间',
      dataIndex: 'capture_time',
      key: 'capture_time',
      align: 'left',
    },
  ]

  const tableData = ref([])
  const loading = ref(false)
  const loadingRecord = ref()
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
  })

  function handleTableChange(page) {
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }

  function fetch() {
    //获取表单值
    const formState = searchFormRef.value?.formState

    loading.value = true
    getData({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
      ...formState,
    }).then(({ data }) => {
      loading.value = false
      tableData.value = data.list
      pagination.value.total = data.total
    })
  }
  
  const cachedSearchParams = computed(() => store.state.search.searchGatePerson)
  onMounted(() => {
    for (const key in cachedSearchParams.value) {
      searchFormRef.value.formState[key] = cachedSearchParams.value[key]
    }
    fetch()
  })
</script>
